import { useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import FeatureGates from '@atlaskit/feature-gate-js-client';

import { useSessionData } from '@confluence/session-data';

import { analytics, STATSIG_END_OF_TRIAL_EXPERIMENT } from '../../experimentConstants';
import { useUserInfo } from '../../store/userInfoStore';
import { useExperimentInfo } from '../../store/experimentInfoStore';

export const useFireExposureEvents = () => {
	const { billingSourceSystem, daysLeftInTrial, modalKey } = useUserInfo();
	const { edition } = useSessionData();
	const { cohort, epMessageReady } = useExperimentInfo();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const fireExposureEvents = useCallback(() => {
		if (
			!edition ||
			!daysLeftInTrial ||
			!billingSourceSystem ||
			!modalKey ||
			!cohort ||
			!epMessageReady
		) {
			return;
		}
		void FeatureGates.manuallyLogExperimentExposure(STATSIG_END_OF_TRIAL_EXPERIMENT);
		createAnalyticsEvent({
			type: 'sendTrackEvent',
			data: {
				action: 'exposed',
				actionSubject: 'feature',
				actionSubjectId: analytics.MODAL_ACTION_SUBJECT_ID,
				attributes: {
					edition,
					daysLeftInTrial,
					cohort,
					billingSourceSystem,
					modalKey,
					epMessageReady,
				},
				source: analytics.SOURCE,
			},
		}).fire();
	}, [
		billingSourceSystem,
		cohort,
		createAnalyticsEvent,
		daysLeftInTrial,
		edition,
		epMessageReady,
		modalKey,
	]);

	return { fireExposureEvents };
};
